//axios api
import api from "@/lib/Api";

export const getAll = async (date) => {
  try {
    const queryRoute = `/outing?all=true&date=${date}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
